module.exports = __webpack_public_path__ + "img/symbol_3.1c3c83f6.png";